import React from 'react';
import { useConsentStatus } from '../hooks/useConsentStatus';
import './ConsentBanner.css';

function fmtDateTime(ts) {
  return new Date(ts).toLocaleString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
}

/**
 * ConsentBanner — global warning strip for consent states the partner must
 * not miss: grace period running out, hard expiry, revocation, and (most
 * important) a pending self-release, which the partner can never cancel.
 * Renders nothing while consent is ordinarily active.
 */
const ConsentBanner = () => {
  const { status, hasPeer } = useConsentStatus();

  if (!hasPeer || !status) return null;

  let level = null;
  let message = null;

  if (status.selfRelease) {
    level = 'warning';
    message = `Self-release in progress on the desktop — monitoring ends ${fmtDateTime(status.selfRelease.effectiveAt)}. It cannot be cancelled from here.`;
  } else if (status.status === 'grace') {
    level = 'warning';
    message = `Monitoring consent has expired — grace ends in ${status.graceHoursRemaining}h. Renewal happens on the desktop.`;
  } else if (status.status === 'expired') {
    level = 'error';
    message = 'Monitoring consent expired — monitoring is paused until the desktop user renews.';
  } else if (status.status === 'revoked') {
    level = 'error';
    message = 'Monitoring consent was revoked. A new grant from the desktop is required.';
  }

  if (!level) return null;

  return (
    <div className={`consent-banner consent-banner-${level}`} role="alert">
      {message}
    </div>
  );
};

export default ConsentBanner;
